<template>
  <a-steps :current="current">
    <a-step
      v-for="key in VIDEO_PIPELINE_STEP_KEYS"
      :key="key"
      :title="$t(`video.${key}`)"
    />
  </a-steps>
</template>

<script setup lang="ts">
import { VIDEO_PIPELINE_STEP_KEYS } from '@/modules/video/constants/video-pipeline-steps'

defineProps<{
  current: number
}>()
</script>
